import { styled } from 'linaria/react';
import Head from 'next/head';
import React, { FC } from 'react';
type Props = {
  statusCode?: number;
  errorMessage?: string;
};
const Page: FC<Props> = ({
  statusCode,
  errorMessage
}) => <>
    <Head>
      <title>
        {' '}
        {statusCode && statusCode === 404 ? '404 お探しのページがみつかりませんでした｜こころから' : 'エラー｜こころから'}
      </title>
      <meta name="robots" content="noindex,follow" />
    </Head>
    <BodyContainer>
      <Header>
        <Div>
          <A href="https://www.cocolocala.jp" />
          <Img1 src="/_cw/static/images/commons/logo-black.png" alt="こころから" />
        </Div>
      </Header>
      <Section>
        <Img2 src="/_cw/static/images/commons/error.png" />
        {statusCode && statusCode === 404 ? <>
            <H1>404</H1>
            <P1>
              {errorMessage ? errorMessage : 'お探しのページがみつかりませんでした。'}
            </P1>
          </> : <>
            <H1>ERROR</H1>
            <P1>
              {errorMessage ? errorMessage : '何らかの問題が発生しました。戻って操作をやり直してください。'}
            </P1>
          </>}
      </Section>

      <P2>© Hotspring, Inc.</P2>
    </BodyContainer>
  </>;
export default Page;
const BodyContainer = /*#__PURE__*/styled("div")({
  name: "BodyContainer",
  class: "b1awd3p"
});
const Header = /*#__PURE__*/styled("header")({
  name: "Header",
  class: "h3iazmo"
});
const Div = /*#__PURE__*/styled("div")({
  name: "Div",
  class: "d1xhepxe"
});
const H1 = /*#__PURE__*/styled("h1")({
  name: "H1",
  class: "h1d2le7h"
});
const P1 = /*#__PURE__*/styled("p")({
  name: "P1",
  class: "pnajjap"
});
const P2 = /*#__PURE__*/styled("p")({
  name: "P2",
  class: "p1xhq6su"
});
const A = /*#__PURE__*/styled("a")({
  name: "A",
  class: "a1s30ss"
});
const Img1 = /*#__PURE__*/styled("img")({
  name: "Img1",
  class: "i1k6gkae"
});
const Img2 = /*#__PURE__*/styled("img")({
  name: "Img2",
  class: "iwn3u07"
});
const Section = /*#__PURE__*/styled("section")({
  name: "Section",
  class: "swycxmg"
});

require("./index.linaria.module.css!=!../../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./index.tsx");